import axios, { AxiosResponse } from 'axios'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import {
  IAssociatedCode,
  ICost,
  ICostAndPrice,
  IDeleteAssociatedCode,
  IDeleteCompound,
  IEditCompound,
  IItem,
  IItemPayload,
  INewAssembly,
  INewAssociatedCode,
  INewCompound,
  IPrice,
  IRotation,
  ISetCompound,
  IUnit,
  IUpdateCompound,
} from 'safe'
import { ITempCostAndPrice } from '../../views/Inventory/CostForm'
import {
  ItemsTypes,
  SET_ITEMS,
  SET_ITEM,
  UPDATE_ITEM,
  SET_ASSOCIATED_CODE,
  AssociatedCodeTypes,
  DELETE_ASSOCIATED_CODE,
  DELETE_ITEM,
  DELETE_COMPOUND_CODE,
  CompoundTypes,
  SET_COMPOUND,
  EDIT_COMPOUND,
  GET_UNIT,
  UnitTypes,
  CostAndPriceTypes,
  ADD_COST_AND_PRICE,
  RotationTypes,
  UPDATE_ROTATION,
  AssemblyTypes,
  DELETE_ASSEMBLY,
  SET_ASSEMBLY,
  EDIT_ASSEMBLY,
  EDIT_CATALOG_STATUS,
} from './actionTypes'

const server = process.env.REACT_APP_SERVER_URL

const setItems = (items: IItemPayload): ItemsTypes => ({
  type: SET_ITEMS,
  payload: items,
})
const setItem = (item: IItem): ItemsTypes => ({ type: SET_ITEM, payload: item })
const editItem = (item: IItem): ItemsTypes => ({
  type: UPDATE_ITEM,
  payload: item,
})
const deleteItem = (itemId: string): ItemsTypes => ({
  type: DELETE_ITEM,
  payload: { itemId },
})

const setAssociatedCode = (
  associatedCode: INewAssociatedCode
): AssociatedCodeTypes => ({
  type: SET_ASSOCIATED_CODE,
  payload: associatedCode,
})

const deleteAssociatedCode = (
  payload: IDeleteAssociatedCode
): AssociatedCodeTypes => ({ type: DELETE_ASSOCIATED_CODE, payload })

const deleteCompound = (payload: IDeleteCompound): CompoundTypes => ({
  type: DELETE_COMPOUND_CODE,
  payload,
})

const deleteAssembly = (payload: IDeleteCompound): AssemblyTypes => ({
  type: DELETE_ASSEMBLY,
  payload,
})

const setCompound = (payload: ISetCompound): CompoundTypes => ({
  type: SET_COMPOUND,
  payload,
})

const setAssembly = (payload: ISetCompound): AssemblyTypes => ({
  type: SET_ASSEMBLY,
  payload,
})

const editCompound = (payload: IEditCompound): CompoundTypes => ({
  type: EDIT_COMPOUND,
  payload,
})

const editAssembly = (payload: IEditCompound): AssemblyTypes => ({
  type: EDIT_ASSEMBLY,
  payload,
})

const createCostAndPrice = (payload: ICostAndPrice): CostAndPriceTypes => ({
  type: ADD_COST_AND_PRICE,
  payload,
})

const editCatalogStatusSend = (payload : {idItem: string, status: boolean}) : ItemsTypes => ({
  type: EDIT_CATALOG_STATUS,
  payload
})

const updateRotation = (payload: IRotation): RotationTypes => ({
  type: UPDATE_ROTATION,
  payload,
})

const getUnits = (payload: IUnit[]): UnitTypes => ({ type: GET_UNIT, payload })

export const fetchItems =
  (
    querySearch: string[] = [],
    paginationParams: string[],
    evaluate = 'none'
  ): ThunkAction<Promise<void>, {}, {}, ItemsTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, ItemsTypes>): Promise<void> => {
    try {
      const response: AxiosResponse<{
        status: number
        items: IItem[]
        numberOfPages: number
      }> = await axios.get(
        `${server}/inventory/item?evaluate=${evaluate}&${[
          ...querySearch,
          ...paginationParams,
        ].join('&')}`
      )
      dispatch(
        setItems({
          item: response.data.items,
          numberOfPages: response.data.numberOfPages,
        })
      )
    } catch (e) {
      throw e
    }
  }

export const createItem =
  (
    item: Omit<IItem, 'id'>,
    hasImage: boolean,
    fd: FormData
  ): ThunkAction<Promise<IItem>, {}, {}, ItemsTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, ItemsTypes>): Promise<any> => {
    let newItem
    // //@ts-ignore
    // item.desired_minimum = "0"
    // //@ts-ignore
    // item.desired_maximum = "0"

    try {
      const response: AxiosResponse<{
        status: number
        newItem: IItem
      }> = await axios.post(`${server}/inventory/item`, {
        entity: item,
      })
      newItem = response.data.newItem
      if (hasImage) {
        // const response2: AxiosResponse<any> = await axios.put(`${server}/media/${newItem.sku}/file?id=${newItem.id}`, fd);
        //http://localhost:3000/media/file?idEntity=1&entity=item
        const response2: AxiosResponse<any> = await axios.put(
          `${server}/media/file?idEntity=${newItem.id}&entity=item`,
          fd
        )
        const image = {
          url: response2.data.file,
        }
        newItem.images.push(image)
        dispatch(setItem(newItem))
        return
      }
      dispatch(setItem(newItem))
    } catch (e) {
      throw e
    }
  }

export const updateItem =
  (
    item: IItem,
    hasImage: boolean,
    fd: FormData
  ): ThunkAction<Promise<void>, {}, {}, ItemsTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, ItemsTypes>): Promise<void> => {
    try {
      const response: AxiosResponse<{
        status: number
        updatedItem: any
      }> = await axios.patch(`${server}/inventory/item`, {
        entity: item,
      })
      const updatedItem = response.data.updatedItem
      if (hasImage) {
        // const response2: AxiosResponse<any> = await axios.put(`${server}/media/${updatedItem.sku}/file?id=${updatedItem.id}`, fd);
        const response2: AxiosResponse<any> = await axios.put(
          `${server}/media/file?idEntity=${updatedItem.id}&entity=item`,
          fd
        )
        const image = {
          url: response2.data.file,
        }
        updatedItem.images.push(image)
        dispatch(editItem(updatedItem))
        return
      } else {
        console.log('llega else...')
        if (item.imageToDelete) {
          axios.put<any>(
            `${server}/media/delete-file?idEntity=${item.imageToDelete.id}&entity=item`,
            {
              data: { originalname: item.imageToDelete.url },
            }
          )
          // newItem.images.push(image)0.
        }
        // dispatch(setItem(newItem))
        // dispatch(setItem(editItem()))
        dispatch(editItem(updatedItem))
      }
    } catch (e) {
      throw e
    }
  }

export const removeItem =
  (itemId: string): ThunkAction<Promise<void>, {}, {}, ItemsTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, ItemsTypes>): Promise<void> => {
    try {
      await axios.delete(`${server}/inventory/item/${itemId}`)
      dispatch(deleteItem(itemId))
    } catch (e) {
      throw e
    }
  }

export const createAssociated =
  (
    associatedCode: IAssociatedCode
  ): ThunkAction<Promise<void>, {}, {}, AssociatedCodeTypes> =>
  async (
    dispatch: ThunkDispatch<{}, {}, AssociatedCodeTypes>
  ): Promise<any> => {
    try {
      const response: AxiosResponse<{
        status: number
        associatedCode: { id: string }
      }> = await axios.post(`${server}/inventory/code`, associatedCode)
      return response
      // dispatch(
      //   setAssociatedCode({
      //     id: response.data.associatedCode.id,
      //     code: associatedCode.code,
      //     itemId: associatedCode.item.id,
      //   })
      // )
    } catch (e) {
      throw e
    }
  }

export const deleteAssociated =
  (
    associatedCodeId: string,
    itemId: string
  ): ThunkAction<Promise<void>, {}, {}, AssociatedCodeTypes> =>
  async (
    dispatch: ThunkDispatch<{}, {}, AssociatedCodeTypes>
  ): Promise<void> => {
    try {
      await axios.delete(
        `${server}/inventory/code/associated/${associatedCodeId}`
      )
      dispatch(deleteAssociatedCode({ id: associatedCodeId, itemId }))
    } catch (e) {
      throw e
    }
  }

export const createCompound =
  (
    compound: {
      compound_item: {
        id: string
      }
      item: {
        id: string
        unit: IUnit
      }
      amount: number
    },
    value: string
  ): ThunkAction<Promise<void>, {}, {}, CompoundTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, CompoundTypes>): Promise<void> => {
    try {
      let response: AxiosResponse<{
        newComposition: INewCompound
      }> = await axios.post(`${server}/inventory/composition`, {
        composition: compound,
      })
      // console.log('compound', compound)
      dispatch(
        setCompound({
          id: response.data.newComposition.id,
          itemId: response.data.newComposition.compound_item.id,
          name: value,
          amount: response.data.newComposition.amount,
          valueId: response.data.newComposition.item.id,
          unit: compound.item.unit,
          cost: response.data.newComposition.item.cost,
          exempt: response.data.newComposition.item.exempt,
          price: response.data.newComposition.item.price,
        })
      )
    } catch (e) {
      throw e
    }
  }

export const createAssembly =
  (
    assembly: {
      assemblyItem: {
        id: string
      }
      productionItem: {
        id: string
        unit: IUnit
      }
      amount: number
    },
    value: string
  ): ThunkAction<Promise<void>, {}, {}, AssemblyTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, AssemblyTypes>): Promise<void> => {
    try {
      console.log('ASSEMBLY', assembly)
      let response: AxiosResponse<{
        newAssembly: INewAssembly
      }> = await axios.post(`${server}/inventory/assembly`, {
        assembly,
      })
      console.log('RESPONSE', response)
      dispatch(
        setAssembly({
          id: response.data.newAssembly.id,
          itemId: response.data.newAssembly.assemblyItem.id,
          name: value,
          amount: +response.data.newAssembly.productionItem.requiredQuantity,
          valueId: response.data.newAssembly.productionItem.id,
          unit: assembly.productionItem.unit,
          cost: response.data.newAssembly.productionItem.cost,
          exempt: response.data.newAssembly.productionItem.exempt,
          price: response.data.newAssembly.productionItem.price,
        })
      )
    } catch (e) {
      throw e
    }
  }

export const removeCompound =
  (
    id: string | undefined,
    itemId: string
  ): ThunkAction<Promise<void>, {}, {}, CompoundTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, CompoundTypes>): Promise<void> => {
    try {
      let response: AxiosResponse<{
        deletedCompoundItem: {
          id
        }
      }> = await axios.delete(`${server}/inventory/composition/${id}`)
      dispatch(
        deleteCompound({ id: response.data.deletedCompoundItem.id, itemId })
      )
    } catch (e) {
      throw e
    }
  }

export const removeAssembly =
  (
    id: string,
    itemId: string
  ): ThunkAction<Promise<void>, {}, {}, AssemblyTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, AssemblyTypes>): Promise<void> => {
    try {
      let response: AxiosResponse<{
        deletedCompoundItem: {
          id
        }
      }> = await axios.delete(`${server}/inventory/assembly/${id}`)

      if (id) {
        dispatch(deleteAssembly({ id, itemId }))
      }

      // dispatch(
      //   deleteCompound({ id: response.data.deletedCompoundItem.id, itemId })
      // )
    } catch (e) {
      throw e
    }
  }

export const updateCompound =
  (
    composition: IUpdateCompound
  ): ThunkAction<Promise<void>, {}, {}, CompoundTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, CompoundTypes>): Promise<void> => {
    try {
      let response: AxiosResponse<{
        updatedComposition: {
          amount: number
          compound_item: { id: string }
          id: string
        }
      }> = await axios.patch(`${server}/inventory/composition`, {
        composition,
      })
      dispatch(
        editCompound({
          id: response.data.updatedComposition.id,
          itemId: response.data.updatedComposition.compound_item.id,
          amount: response.data.updatedComposition.amount,
        })
      )
    } catch (e) {
      throw e
    }
  }

export const updateAssembly =
  (
    assembly: IUpdateCompound
  ): ThunkAction<Promise<void>, {}, {}, AssemblyTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, AssemblyTypes>): Promise<void> => {
    try {
      let response: AxiosResponse<{
        updatedAssembly: {
          amount: number
          assemblyItem: { id: string }
          id: string
        }
      }> = await axios.patch(`${server}/inventory/assembly`, {
        assembly,
      })

      console.log('response', response)

      dispatch(
        editAssembly({
          id: response.data.updatedAssembly.id,
          itemId: response.data.updatedAssembly.assemblyItem.id,
          amount: assembly.amount,
        })
      )
    } catch (e) {
      throw e
    }
  }

export const addPriceAndCost =
  (
    costAndPrice: ITempCostAndPrice
  ): ThunkAction<Promise<void>, {}, {}, CostAndPriceTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, CostAndPriceTypes>): Promise<void> => {
    try {
      let response: AxiosResponse<{
        costsAndPrices: {
          id_item: string
          cost: ICost
          price: IPrice
        }
      }> = await axios.post(`${server}/inventory/item/cost_price`, {
        entity: costAndPrice,
      })
      dispatch(
        createCostAndPrice({
          id_item: response.data.costsAndPrices.id_item,
          cost: response.data.costsAndPrices.cost,
          price: response.data.costsAndPrices.price,
        })
      )
    } catch (e) {
      throw e
    }
  }

export const setRotation =
  (rotation: IRotation): ThunkAction<Promise<void>, {}, {}, RotationTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, RotationTypes>): Promise<void> => {
    try {
      let response: AxiosResponse<{
        newBatch: {
          id: string
          creationDate: string
          expirationDate: string
          rotationDate: string
          batch: string
          id_item: string
        }
      }> = await axios.post(`${server}/inventory/batch`, {
        batch: rotation, 
      })
      dispatch(
        updateRotation({
          creationDate: response.data.newBatch.creationDate,
          expirationDate: response.data.newBatch.expirationDate,
          rotationDate: response.data.newBatch.rotationDate,
          batch: response.data.newBatch.batch,
          id_item: response.data.newBatch.id_item,
          id: response.data.newBatch.id
        })
      )
    } catch (e) {
      throw e
    }
  }

export const fetchUnits =
  (): ThunkAction<Promise<void>, {}, {}, UnitTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, UnitTypes>): Promise<void> => {
    try {
      let response: AxiosResponse<{
        units: IUnit[]
      }> = await axios.get(`${server}/tools/unit`)
      dispatch(getUnits(response.data.units))
    } catch (e) {
      throw e
    }
  }

  export const editCatalogStatus = (idItem : string, status: boolean): ThunkAction<Promise<void>, {}, {}, ItemsTypes> =>
  async (dispatch: ThunkDispatch<{}, {}, ItemsTypes>): Promise<void> => {
    try {
      let response: AxiosResponse<any> = await axios.patch(`${server}/inventory/item/${idItem}/catalog`, {catalog: status})
      dispatch(
        editCatalogStatusSend({idItem, status})
      )
    } catch (e) {
      throw e
    }
  }